module.exports = __webpack_public_path__ + "img/mt.3ae768e7.svg";